import {
  Button,
  Modal,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";

const DeleteModalConfirmation = ({
  deleteOpen,
  setDeleteOpen,
  rowToDelete="",
  deleteButtonText,
  onConfirmDelete,
}) => {
  return (
    <Modal open={deleteOpen} onClose={() => setDeleteOpen(false)}>
      <Dialog open={deleteOpen} onClose={() => setDeleteOpen(false)}>
        <DialogTitle sx={{ fontWeight: 600 }}>{deleteButtonText}</DialogTitle>

        <DialogContent>
          <Typography sx={{ color: "#64748b" }}>
            Are you sure you want to delete{" "}
            <b>{rowToDelete?.name || "this record"}</b>? This action cannot be
            undone.
          </Typography>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={() => setDeleteOpen(false)}
            sx={{ textTransform: "none" }}
          >
            Cancel
          </Button>

          <Button
            color="error"
            variant="contained"
            onClick={onConfirmDelete}
            sx={{ textTransform: "none" }}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </Modal>
  );
};

export default DeleteModalConfirmation;
